// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.
import fn from '../../setQuarter/index.js';
import convertToFP from '../_lib/convertToFP/index.js';
var setQuarter = convertToFP(fn, 2);
export default setQuarter;


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/fp/setQuarter/index.js
// module id = 979
// module chunks = 0